import { Box, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { getPresence } from './presence';

const PresenceBadge = ({ presence, size = 'medium', noWrap = false }) => {
  const { t } = useTranslation();
  const formatted = getPresence(presence, new Date(), t);
  const dotSize = size === 'small' ? 8 : 12;

  return (
    <Stack
      direction="row"
      spacing={0.75}
      alignItems="center"
      sx={{ minWidth: 0, maxWidth: '100%' }}
    >
      <Box
        aria-hidden="true"
        sx={{
          width: dotSize,
          height: dotSize,
          borderRadius: '50%',
          bgcolor: formatted.color,
          flexShrink: 0,
          boxShadow:
            formatted.status === 'online'
              ? '0 0 0 4px rgba(47, 138, 86, 0.12)'
              : 'none',
        }}
      />
      <Typography
        variant="subtitle2"
        color={formatted.color}
        sx={{
          lineHeight: 1.1,
          minWidth: 0,
          ...(noWrap
            ? {
                maxWidth: '100%',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
              }
            : {}),
        }}
      >
        {formatted.label}
      </Typography>
    </Stack>
  );
};

export default PresenceBadge;
